import { DetailValue } from 'components/common'
import { getDetailUrl } from 'models/RPSTariff/api'


const RPSTariffValue = ({ detail, asLink, isBack }) => {
  return (
    <DetailValue
      url={asLink && getDetailUrl(detail)}
      isBack={isBack}
      className="flex"
      render={() => (
        <>
          {detail?.Name || '-'}
        </>
      )}
    />
  );
};


export default RPSTariffValue
